module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-48.d96de998.jpg";